export const loginRtkKey = 'login';

export const forgotPasswordRtkKey = 'forgotPasswordSendOtp';

export const signupRtkKey = 'signup';

export const getPhoneCodeRtkKey = 'getPhoneCode';

export const verifyOtpRtkKey = 'verifyOtp';

export const getRoleListRtkKey = 'getRoleList';

export const getAccessLevelListRtkKey = 'getAccessLevelList';

export const getPermissionListRtkKey = 'getPermissionList';

export const resetPasswordRtkKey = 'resetPassword';

export const changePasswordRtkKey = 'changePassword';

export const resendOtpRtkKey = 'resendOtp';

export const updateDetailsRtkKey = 'updateDetails';

export const getProfileRtkKey = 'getProfile';

export const getUserListRtkKey = 'getUserList';

export const getUserDetailRtkKey = 'getUserDetail';

export const deleteUserRtkKey = 'deleteUserById';

export const createUserRtkKey = 'createUser';

export const updateUserRtkKey = 'updateUserById';

export const getRoleManagementListRtkKey = 'getRoleManagementList';
export const createRoleRtkKey = 'createRole';
export const updateRoleRtkKey = 'updateRole';
export const deleteRoleRtkKey = 'deleteRole';

export const getPermissionManagementListRtkKey = 'getPermissionManagementList';
export const createPermissionRtkKey = 'createPermission';
export const updatePermissionRtkKey = 'updatePermission';
export const deletePermissionRtkKey = 'deletePermission';

export const getTemplateListRtkKey = 'getTemplateList';
export const createTemplateRtkKey = 'createTemplate';
export const getTemplateDetailRtkKey = 'getTemplateDetail';
export const deleteTemplateRtkKey = 'deleteTemplate';
export const downloadTemplateRtkKey = 'downloadTemplate';
export const getTemplateForUserRtkKey = 'getTemplateForUser';
export const uploadTemplateRtkKey = 'uploadTemplate';
export const getChartListRtkKey = 'getChartListRtkKey';
export const getChartDetailsRtkKey = 'getChartDetailsRtkKey';
export const getChartDataRtkKey = 'getChartData';
export const getChartDataByKpiRtkKey = 'getChartDataByKpi';




export const getIndicatorListRtkKey = 'getIndicatorList';

export const deleteTemplateDataRtkKey = 'deleteTemplateData';

export const getActivityLogRtkKey = 'getActivityLog';

export const getDataHouseRtkKey = 'getDataHouse';

export const getDataHouseDetailsRtkKey = 'getDataHouseDetails';
export const deleteDataHouseRtkKey = 'deleteDataHouse';